var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicesMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8398 6.61328L8.07031 0.84375C7.82422 0.597656 7.49609 0.433594 7.14062 0.433594H1.5625C0.824219 0.433594 0.25 1.03516 0.25 1.74609V7.35156C0.25 7.70703 0.386719 8.03516 0.632812 8.28125L6.40234 14.0508C6.92188 14.5703 7.76953 14.5703 8.26172 14.0508L13.8398 8.47266C14.3594 7.98047 14.3594 7.13281 13.8398 6.61328ZM3.3125 4.80859C2.57422 4.80859 2 4.23438 2 3.49609C2 2.78516 2.57422 2.18359 3.3125 2.18359C4.02344 2.18359 4.625 2.78516 4.625 3.49609C4.625 4.23438 4.02344 4.80859 3.3125 4.80859ZM17.3398 8.47266C17.8594 7.98047 17.8594 7.13281 17.3398 6.61328L11.5703 0.84375C11.3242 0.597656 10.9961 0.433594 10.6406 0.433594H9.30078L14.6602 5.82031C15.125 6.28516 15.3984 6.88672 15.3984 7.54297C15.3984 8.19922 15.125 8.82812 14.6602 9.29297L9.90234 14.0508C10.4219 14.5703 11.2695 14.5703 11.7617 14.0508L17.3398 8.47266Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesMenuIcon);
export default __webpack_public_path__ + "static/media/ServicesMenuIcon.460ff818.svg";
export { ForwardRef as ReactComponent };